import useSWR from 'swr'
import { PendingScheduleType } from '../common/types/calendar'
import { convertPendingSchedules, Row } from '../options/convertPendingSchedules'
import fetchPendingSchedules from '../options/fetchPendingSchedules'
import { useAuth } from '../../hooks/use-auth'

type Response = {
  isError: boolean
  isLoading: boolean
  pendingSchedules: PendingScheduleType[] | undefined
}

const usePendingSchedules = (): Response => {
  const auth = useAuth()
  const { data, error } = useSWR<Row[] | undefined>('/api/pendingSchedules', () =>
    fetchPendingSchedules(auth.authorizationHeader, auth.factoryId)
  )
  const pendingSchedules = convertPendingSchedules(data || [])

  return {
    isError: !!error,
    isLoading: !error && !pendingSchedules,
    pendingSchedules: pendingSchedules,
  }
}

export default usePendingSchedules
